export default __webpack_public_path__ + "static/media/home-creative-agency-bg-img-01.9513312a.jpg";